<template>
	<Overlay
		ref="overlay"
		class="overlay--edit"
		:root="true"
		:title="title"
		@afterhide="afterhide"
	>
		<template v-slot:body>
			<slot />
		</template>

		<template v-slot:footer>
			<div
				:class="{ 'overlay-footerContent--hidden': !applyIsVisible }"
				class="overlay-footerContent"
			>
				<div class="footer-actions-group">
					<button
						class="button button--light button--carnation"
						@click.prevent="_onCloseClick"
					>
						Annuleren
					</button>
					<button
						type="submit"
						name="button"
						class="button button--filled overlay-applyButton"
						@click.prevent="_onApplyClick"
					>
						{{ submitName }}
					</button>
				</div>
			</div>
		</template>
	</Overlay>
</template>

<script src="./EditOverlay.js"></script>
